import { FormikProps } from 'formik'
import { FC, useCallback, useEffect, useMemo, useState } from 'react'
import { AgGridTable } from '../../../utils/agGridTable/AgGridTable'
import { AgGridTable2 } from 'app/utils/agGridTable/AgGridTable2'
import { Button } from '../../../utils/Button'
import ArrayInput from '../../../utils/form/ArrayInput'
import { useBetween } from 'use-between'
import { propsInterfaceFormGroupInput } from '../../../utils/form/FormGroupInput'
import { BTCreateContract6 } from '../BTContract/BTCreateContract6'
import { BTCreateContract2 } from '../BTContract/BTCreateContract2'
import { ActionDataGrid6 } from './ActionDataGrid6'
import { callSP } from '../../../../setup/axios/AxiosCallSP'
import { ModalForm } from '../../../utils/modal/ModalForm'
import { warn, error } from '../../../utils/customToasd'
import { quitarDuplicadoReceta } from '../../minutas/grillas/gridService'
import { getColumRecetaGrid, isValid } from './step.service'
import { get_set_ls } from "global.d";
const StepContract6: FC<StepContract6Props> = (props) => {
  const { setDataRow6, dataRow6 } = useBetween(BTCreateContract6)
  const [infoModal, setInfoModal] = useState<boolean>(false)
  const { setDataRow2, dataRow2 } = useBetween(BTCreateContract2)
  const [addRow, setAddRow] = useState(false)
  const [open, setOpen] = useState(false)
  const columInput = 4
  const [gridRef, setGridRef] = useState<any>()
  const [arrayInput, setArrayInput] = useState<propsInterfaceFormGroupInput[]>([])
  const [estructuras, setEstructuras] = useState<any>([])
  const [columnDefs] = useState([
    { field: 'contrato', headerName: 'Contrato', minWidth: 120 },
    { field: 'id', hide: true },
    { field: 'fatherStructure4', headerName: 'Grupo estructura', minWidth: 200, rowDrag: true },
    { field: 'structure', headerName: 'Estructura', minWidth: 200 },
    { field: 'idRecipe', headerName: 'Id Receta', minWidth: 100 },
    { field: 'recipe', headerName: 'Receta', minWidth: 180 },
    {
      field: 'Acción',
      minWidth: 150,
      cellRenderer: (params: any) => {
        return <ActionDataGrid6 dataRow={params.node.data} />
      },
      cellEditor: 'agRichSelectCellEditor',
      cellEditorPopup: true,
    },
  ])
  let arr_input: any = [
    {
      columInput: columInput,
      campo: 'fatherStructure4',
      label: 'Grupoo estructura',
      type: 'autocomplete',
      advanceOptions: {
        id: 'fatherStructure',
        multiple: false,
        placeholder: 'Ingrese Grupo Estructura',
        options: props.data.grupoEstructuras,
      },
      onChange: async (event: any, setFieldValue: any, values: any) => {
        if (event == "") {
          return
        }
        let grp_est_selected: any = event.current.props.selected[0]

        props.formikProps?.setFieldValue('fatherStructure', [
          { text: grp_est_selected.text, value: grp_est_selected.value },
        ])

        // Limpiar el campo de estructura cuando se cambia el grupo
        props.formikProps?.setFieldValue('structure', [{ text: '', value: '' }])

        if (grp_est_selected?.value && grp_est_selected?.value != '') {
          try {
            const resp: any = await getEstructuras(grp_est_selected.value.toString())
            // Actualizar arr_input y luego actualizar el estado arrayInput
            arr_input[1].advanceOptions.options = resp
            setEstructuras(resp)
            // Actualizar el estado arrayInput para que el componente se re-renderice con las nuevas opciones
            setArrayInput([...arr_input])
          } catch (e: any) {
            error(e)
          }
        } else {
          // Si no hay grupo seleccionado, limpiar las opciones de estructura
          arr_input[1].advanceOptions.options = []
          setEstructuras([])
          setArrayInput([...arr_input])
        }
      },
      className: 'form-control form-control-lg step-2  input-contract',
    },
    {
      columInput: columInput,
      campo: 'structure',
      label: 'Ingrese Estructura',
      type: 'autocomplete',
      //disabled: disabledInput,
      advanceOptions: {
        id: 'structure',
        placeholder: 'Ingrese Estructura',
        multiple: false,
        options: estructuras,
      },
      onChange: async (event: React.ChangeEvent<HTMLInputElement>, setFieldValue: any, arrayInput: any) => {
      },
      className: 'form-control form-control-lg step-2  input-contract',
    },
    {
      columInput: columInput,
      campo: 'recipe',
      label: 'Receta Estructura Fija',
      type: 'autocomplete',
      advanceOptions: {
        id: 'recipe',
        multiple: false,
        placeholder: 'Ingrese Estructura Fija',
        options: quitarDuplicadoReceta(props.data.recetaEstructuraFijas, 'rec_codigo'),
      },
      onChange: async (event: any) => { },
      className: 'form-control form-control-lg step-2  input-contract',
    },
  ]
  useEffect(() => {
    if (props.isReady) {
      dataRow2.map((e: any) => {
        return {
          ...e,
          text: e.structure,
          value: e.id,
        }
      })

      // Actualizar arr_input con las estructuras actuales antes de establecer el estado
      arr_input[1].advanceOptions.options = estructuras
      setArrayInput([...arr_input])
    }
  }, [props.isReady, dataRow2, estructuras])

  const clearInput = (id: string, obj: any) => {
    props.formikProps?.setFieldValue(id, [{ text: '', value: '' }])
    obj[id][0] = { text: '', value: '' }
  }


  const getEstructuras = async (group: any) => {
    try {
      // Intentar obtener el servicio de diferentes formas
      let serviceValue = null
      
      // Primero intentar desde formikProps
      const service = props.formikProps?.values?.service?.[0]
      if (service?.value) {
        serviceValue = service.value
      } else if (props.formikProps?.values?.service) {
        // Si service es un array pero no tiene [0], intentar obtener el valor directamente
        const serviceArray = props.formikProps.values.service
        if (Array.isArray(serviceArray) && serviceArray.length > 0) {
          serviceValue = serviceArray[0]?.value || serviceArray[0]
        } else if (typeof props.formikProps.values.service === 'object' && props.formikProps.values.service.value) {
          serviceValue = props.formikProps.values.service.value
        }
      }
      
      // Si aún no tenemos el servicio, intentar obtenerlo desde props.data.servicio (pasado desde CreateContract)
      if (!serviceValue && props.data?.servicio) {
        serviceValue = props.data.servicio
      }
      
      if (serviceValue && serviceValue != '') {
        const dataEstructuras: any = await callSP('amd_getEstructuraByServicio', [
          { text: 'servicio', value: serviceValue.toString() },
          { text: 'agrupa_estructura', value: group },
        ])

        if (dataEstructuras.data.status != '200') {
          throw 'Error al consultar estructura por servicio!'
        }

        let arrEst: any[] = dataEstructuras.data.result.map((e: any) => {
          return {
            ...e,
            text: e.ess_nombre,
            value: e.ess_codigo.toString(),
          }
        })

        if (dataRow2.length) {
          dataRow2.forEach((e: any) => {
            let index: any = arrEst.findIndex((i: any) => i.value == e.idStructure)
            if (index != -1) {
              arrEst.splice(index, 1)
            }
          })
        }
        setEstructuras(arrEst)
        return arrEst
      } else {
        warn('Debe seleccionar un servicio en el paso 1 (Contrato) antes de agregar estructuras fijas!')
        return []
      }
    } catch (e: any) {
      error(e)
      return []
    }
  }

  const validateAdd = (values: any) => {

    if (!isValid(values, 'fatherStructure4', 'Debe selecionar grupo de estructura')) return false
    if (!isValid(values, 'recipe', 'Debe selecionar receta')) return false
    get_set_ls("estNuevo", values['recipe'][0].value)
    get_set_ls("estGENuevo", values.fatherStructure4[0].value)
    
    if (dataRow6.length) {
      let receta: any = values['recipe'][0]

      let index: any = dataRow6.findIndex((e: any) => receta.value == e.idRecipe)
      if (index != -1) {
        warn(`Receta fija ${receta.text} ya ha sido agregada!`)
        clearInput('recipe', values)

        return false
      }
    }

    return true
  }

  useMemo(() => {
    if (!addRow) {
      return
    }
    let obj = props.formikProps?.values

    if (validateAdd(obj)) {
      // if (obj.recipe) {
      //   if (obj.recipe.length > 0) {
      let row = dataRow6.slice()

      obj.id = row.length
      let formContract3: contStep6 = {
        id: row.length,
        data: JSON.parse(JSON.stringify(obj)),
        recipe: obj.recipe[0].text,
        idRecipe: obj.recipe[0].value,
        fatherStructure4: obj.fatherStructure4[0].text,
        idFatherStructure4: obj.fatherStructure4[0].value,
        structure: obj.structure[0].text,
        id_estructura: obj.structure[0].value,
        contrato: props.formikProps?.values?.contractId, // Agregar el contrato desde formik
      }
      get_set_ls("estIDGENuevo", obj.structure[0].value)
      row.push(formContract3)
      setDataRow6(row)
      clearInput('recipe', obj)
      clearInput('fatherStructure4', obj)
      clearInput('structure', obj)
      //   }
      // }
    }
  }, [open])

  const filter = useCallback(

    async (params: any) => {

      let row = dataRow6.slice()
      let formContract3: contStep6 = {
        id: params.data.id,
        data: JSON.parse(JSON.stringify(params.data)),
        recipe: params.data.text,
        idRecipe: params.data.value,
        fatherStructure4: params.data.fatherStructure4,
        idFatherStructure4: params.data.idFatherStructure4,
        structure: params.data.structure,
      }
      row.push(formContract3)
      setDataRow6(row)
      setInfoModal(false)
    },
    [dataRow6]
  )

  const onDrag = useCallback((e: any, data: any) => {
    //props.setLoad(true)
    let rows6: any = [];
    e.api.forEachNodeAfterFilterAndSort((node: any) => rows6.push(node.data));
    rows6.forEach((item: any, key: number) => { item.order = key; item.id = key });
    setDataRow6(rows6)
    gridRef?.current?.api?.setRowData(rows6)
    //props.setLoad(false)
  }, [gridRef])

  return (
    <div className='w-100'>
      <div className=''>
        <h2 className='text-dark'>{props.title}</h2>
        <div className='text-gray-400 fw-bold fs-6'>{props.subTitle}</div>
      </div>
      <hr />
      <ArrayInput classContainer='container-input' arrayInput={arrayInput} />
      <i
        className='bi bi-search search-fixed-structure'
        onClick={() => {
          setInfoModal(true)
        }}
      ></i>
      <Button
        className='btn-agregar'
        type='button'
        onClick={() => {
          let r = !open
          setAddRow(true)
          setOpen(r)
        }}
      >
        {props.title}
      </Button>
      <AgGridTable2 columnDefs={columnDefs} rowHeight={90} rowDrag={true} pagination={false} dataRow={dataRow6} setAGGridRef={setGridRef} onRowDrag={onDrag} />
      {infoModal && (
        <ModalForm
          colum={getColumRecetaGrid(filter)}
          showSave={false}
          showClose={false}
          modalFullscreen={true}
          title={'Seleccionar Estructura'}
          rows={quitarDuplicadoReceta(props.data.recetaEstructuraFijas, 'rec_codigo')}
          show={infoModal}
          saveName={'Seleccionar Estructura'}
          close={() => {
            setInfoModal(false)
          }}
          save={() => {
            setInfoModal(false)
          }}
        />
      )}
    </div>
  )
}
export interface contStep6 {
  id?: number
  contrato?: string | number
  fatherStructure4?: string
  idFatherStructure4?: number
  mainIngredients?: string
  recipe?: string
  idRecipe?: number
  cycleWeek?: string
  data?: any
  load?: boolean
  idEstRel?: number
  id_estructura?: string
  nombre_estructura?: string
  structure?: string
}
interface StepContract6Props {
  title?: string
  subTitle?: string
  onChange?(e: React.ChangeEvent<HTMLInputElement>): void
  formikProps?: FormikProps<any>
  data?: any
  isReady?: boolean,
  setLoad?: any
}
export { StepContract6 }
